// extracted by css-extract-rspack-plugin
export default {"bar":"browsies-module__bar___GNk5g","title":"browsies-module__title___r2jDV","selected":"browsies-module__selected___etVUi","mobile":"browsies-module__mobile___ch6Iw"};